// extracted by mini-css-extract-plugin
export default {"claimSummaryRow":"_1_wgM2sYslOzR5Zy0ke-ec","rowBoxShadow":"_3EV8yGo9gkwUHmm5N4Ps-O","horizontalLineMargin":"_32G7mnQ4KQ91yNXMqRb70I","rowPaddings":"nZOYxOJ2VK21LshjtKNA0"};